// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSearch_root__1nUaU"};